declare global {
  interface Window {
    __NATIVE_API_BASE__?: string
    __NATIVE_APP__?: boolean
  }
}

/** Base da API injetada no build nativo (index.html) ou via VITE_API_URL. */
export function getRuntimeApiBase(): string {
  if (typeof window !== 'undefined') {
    const injected = window.__NATIVE_API_BASE__
    if (typeof injected === 'string' && injected.trim()) {
      return injected.trim().replace(/\/$/, '')
    }
  }
  return String(import.meta.env.VITE_API_URL ?? '')
    .trim()
    .replace(/\/$/, '')
}

export function isNativeAppRuntime(): boolean {
  if (typeof window !== 'undefined' && window.__NATIVE_APP__ === true) return true
  if (typeof __NATIVE_APP_BUILD__ !== 'undefined' && __NATIVE_APP_BUILD__) return true
  return false
}

export function isCapacitorLocalHost(): boolean {
  if (typeof window === 'undefined') return false
  try {
    const { hostname } = window.location
    return hostname === 'localhost' || hostname === '127.0.0.1'
  } catch {
    return false
  }
}
